<template>
  <div class="page">
    <div class="content">
      <div class="card">
        <div class="row">
          <div class="title">淘宝或京东订单号</div>
        </div>
        <div class="phone" :empty="!form.OrderNo">
          <van-field
            type="text"
            v-model="form.OrderNo"
            placeholder="输入订单号"
          />
        <div class="input-item" v-if="isShowVerifyCode" >
            <div class="input-layout">
                <input placeholder="请输入验证码" v-model="form.VerifyCode" maxlength="6" />

            </div>
                <img class="right_img" :src="verifyImg" @click="getImg()" title="点击刷新"/>
        </div>
          <div class="btn">
            <y-button @click="submit">确认提交</y-button>
          </div>
        </div>
      </div>
      <div class="about">
        <h5>如何获取订单号</h5>
        <div class="tab-con">
          <van-tabs v-model="active">
            <van-tab title="淘宝订单">
              <img src="@/assets/add-card-about-1.png" />
            </van-tab>
            <van-tab title="京东订单">
              <img src="@/assets/add-card-about-2.png" />
            </van-tab>
          </van-tabs>
          <p>如您对获取订单号的流程仍有任何疑问可咨询<span @click="goto('KF_SERVICE')">客服中心</span></p>
        </div>
      </div>
    </div>
    <van-dialog v-model="errorDialog" confirmButtonText="好的">
      <div class="error-dialog">
        <div>{{errorMessage}}</div>
        <div class="tel" v-if="isShowTel">如有疑问，可咨询：<a href="tel://400-088-9898">400-088-9898</a></div>
        <div class="view-success"  v-if="isShowView">查看<span @click="goto('/care/list')">我的无忧卡</span></div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { login } from "../../scripts/auth";
import { httpOpen } from "../../scripts/network";
import Vue from "vue";
import { Field, Uploader,Tab, Tabs,Dialog} from "vant";
import uuid from 'uuid';

Vue.use(Uploader);
Vue.use(Field);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Dialog);
export default {
  name: "CareActive",
  data() {
    return {
      form:{},
        errorDialog:false,
        errorMessage:'',
        isShowTel:false,
        isShowView:false,
        isShowVerifyCode: false,
        tag: "",
        verifyImg: null,
        verifyImg2: null,
        active: 0
    };
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    async submit() {
        this.isShowTel = false
        this.isShowView = false
      if (!this.form.OrderNo) {
          this.errorMessage = "请输入第三方订单号！"
          this.errorDialog = true
          return;
      }
      if(this.isShowVerifyCode)
      {
        if (!this.form.VerifyCode) {
            this.errorMessage = "请输入验证码！"
            this.errorDialog = true
            return;
        }  
      }
        this.$loading.show("正在加载...");
        try {
            console.log(this.form);
            this.form.tag = this.tag;
            const ret = await httpOpen("/WuYouCard/BindOrder", {
                type: "post",
                body: this.form,
            });
            this.$loading.hide();
            //console.log(ret);
                        
            if (ret != null && ret.Data != null) {
                this.isShowVerifyCode = ret.Data.isShowVerifyCode;
                if(this.isShowVerifyCode)
                {
                    this.getImg();
                }
            }
            if (!ret.Status && parseInt(ret.ErrorCode) === 401) {
                login(this.$store, this.$router);
                return;
            } else if (!ret.Status) {
                this.errorMessage = ret.Message || "系统繁忙"
                this.errorDialog = true
                this.isShowTel = true
            } else {
                this.errorMessage = "绑定成功！"
                this.errorDialog = true
                this.isShowView = true
            }

        } catch (e) {
            console.error(e);
        }
    },
    async getImg() {
        this.isShowTel = false
        this.isShowView = false
          let newUuid = uuid.v4();
          this.tag = newUuid.replace(/[-]/g, '');
          //console.log(this.tag);
          const params = { param: { "para.tag": this.tag, "para.width": 120, "para.height": 40 } };
          let ret;
          try {
            ret = await httpOpen('/WuYouCard/GetImgValidCode', params)
          } catch (error) {
            console.error('----', error)
          }
          if (ret && ret.Status) {
            this.verifyImg = ret.Data;
            //console.log(ret.Data);
          }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.row {
  display: flex;
  flex-direction: row;
}
.page {
  min-height: 100vh;
  padding-bottom: 83px;
  overflow: unset;
}
.content {
  position: absolute;
  z-index: 1;
  top: 0;
  width: 100%;
  padding-top: 77%;
  background: #101010 url("~@/assets/card-bind-bg.png") 0 0 no-repeat;
  background-size: 100%;
}
.card {
  border-radius: 6px;
  background: white;
  margin: 0 16px 0 16px;
  padding: 16px;
  box-shadow: 0px 0px 11px 0px rgba(0, 0, 0, 0.14);
}
.card .btn{
  margin-top: 24px;
}
.card .row {
  justify-content: space-between;
}
.row .title {
  color: #000000;
  font-size: 14px;
  font-weight: 600;
}
.row .info {
  color: black;
  font-size: 16px;
  font-weight: bold;
}
.phone {
  position: relative;
}
.phone >>>input{
  font-size: 18px !important;
}
.content >>>input{
  padding: 10px 10px;
  color: #000;
}
.content >>>input::placeholder{
  color: #666;
  font-size: 17px;
}

.van-field {
  font-size: 16px;
  font-weight: 500;
  margin-top: 6px;
  padding: 4px 6px !important;
  border-radius: 3px;
  background-color: #f5f5f5;
}
  .about{
    padding: 16px;
    margin-top: 10px;
  }
.about h5{
  font-size: 14px;
  color: #ffffff;
  margin: 0 0 10px 0;
}
  .about .tab-con{
    background: #303030;
    border-radius: 8px;
    padding: 18px;
    text-align: center;
  }
.about .van-tab__pane{
    padding: 30px;
  }
.about .van-tab__pane img{
  max-width: 100%;
}
.about >>>.van-tabs__nav{
  background-color: transparent;
}
.about >>>.van-tab{
  color: #fff;
}
.about >>>.van-tab--active{
  color: #FFDBB4;
}
.about >>>.van-hairline--top-bottom::after, .about >>>.van-hairline-unset--top-bottom::after{
  border: none;
}
.about >>>.van-tabs__line{
  background-color: #FFDBB4;
}
.about .tab-con p{
  color: #fff;
  font-size: 13px;
  width: 65%;
  margin: 0 auto;
  line-height: 1.5;
  text-align: left;
}
.about .tab-con p span{
  color: #47A5FF;
}
  .error-dialog{
    padding: 15px;
    text-align: center;
  }
.error-dialog .tel a,.error-dialog .view-success span{
  color: #47A5FF;
}
.input-item {
    display: flex;
    align-items: flex-end;
    flex-direction: row;
}

.input-item+.input-item {
    margin-top: 30px;
    height:40px;
}

.input-layout {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1 1;
    margin-top: 10px;
}
.input-layout input{
    font-size: 16px;
    border-radius: 3px;
    background-color: #f5f5f5;
    padding-left:15px;
    width: 55%;
    min-width: 150px;
    height:30px;
}

.right_img {
    padding: 5px 0px;
    vertical-align: middle;
    width: 45%;
    min-width: 120px;
    height:40px;
}
</style>
